import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import usePost from '../../hooks/usePost';
import useUserById from '../../hooks/useUserById';
import { RiCalendarCheckLine, RiErrorWarningLine, RiVipCrownLine } from 'react-icons/ri';
import useSpots from '../../hooks/useSpots';
import { BiCurrentLocation, BiLike, BiUserVoice } from 'react-icons/bi';
import { MdReport, MdUpdate } from 'react-icons/md';
import { BsFillBookmarkStarFill, BsPeopleFill } from 'react-icons/bs';
import { GiMoneyStack } from 'react-icons/gi';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase.init';
import { FaCheck, FaStar } from 'react-icons/fa';
import { AiOutlineArrowRight } from 'react-icons/ai';
import useUser from '../../hooks/useUser';
import { useState } from 'react';
import { ImCross } from 'react-icons/im';
import { TiWarningOutline } from 'react-icons/ti';
import axios from 'axios';
import { toast } from 'react-toastify';
import Navbar from '../Shared/Navbar';

const PostDeatils = () => {

    const { id } = useParams();

    function formatTime(time) {
        const hourString = time?.slice(0, time?.indexOf(':'));
        const minute = time?.slice(time?.indexOf(':') + 1, time?.length);
        const hour = +hourString % 24;
        return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
    }

    const [post, setPost] = usePost(id);
    const [userq] = useUserById(post?.uid);
    const [user, loading] = useAuthState(auth);
    const [userc] = useUser(user?.email);

    //console.log(post);

    const inPersons = post?.interested?.filter(i => i?.id !== userc?._id);
    //console.log(inPersons);

    const inGuides = post?.job?.filter(j => j?.id !== userc?._id);
    //console.log(inGuides);

    const getPost = async () => {
        await axios.get(`https://tripaide-server.onrender.com/posts/${id}`)
            .then(res => {
                setPost(res.data);
                //console.log(res.data);
            });
    }

    let navigate = useNavigate();
    const handleUpdatedData = async (newPost) => {
        await axios.put("https://tripaide-server.onrender.com/posts", newPost)
            .then(res => {
                //console.log(res.data);
                //const id = res.data.insertedId;
                getPost();
            });
    };

    const handleStart = () => {
        const updatedData = {
            id: post.id,
            state: "Ongoing"
        };
        handleUpdatedData(updatedData);
    }

    const handleDelete = async (iid) => {
        const inP = post?.interested?.filter(i => i?.id !== iid);
        //console.log(inPersons);
        const updatedData = {
            id: post.id,
            interested: inP
        };
        //console.log(updatedData);
        handleUpdatedData(updatedData);
    }
    const handleSelect = async (g) => {
        const inG = post?.job?.filter(i => i?.id === g);
        //console.log(inG);
        const updatedData = {
            id: post.id,
            job: inG,
            guide: g?.name,
            guideId: g?.id
        };
        //console.log(updatedData);
        handleUpdatedData(updatedData);
    }

    const handleCancel = () => {
        handleDelete(post?.id);
    }

    return (
        <div>
            <Navbar />
            <div className='w-11/12 mx-auto bg-gray-100 p-8 my-8 rounded-xl shadow-custom-lg'>
                <div className='flex justify-between mb-4'>
                    <div className='cursor-pointer flex items-center bg-trans px-2 text-yellow-500 rounded font-medium text-sm'>
                        <RiVipCrownLine className='mr-1' />
                        <span>{post?.type}</span>
                    </div>
                </div>
                <div className='md:flex justify-between font-semibold'>
                    <div className='md:flex items-center'>
                        <p className='text-sm'>Posted By</p>
                        <Link className='ml-2 text-lg text-pink-600 block' to={`/u/${post?.uid}`}>{post?.owner}</Link>
                        <div className='hidden md:flex items-center justify-start text-sm ml-4'>
                            <BsFillBookmarkStarFill className='text-yellow-500' />
                            <p className='font-semibold pl-1'>{userq?.rating}</p>
                        </div>
                    </div>
                    {
                        post?.state === "Running" && <div className='h-6 bg-trans text-white px-2 rounded inline-flex items-center cursor-pointer'>
                            <div className="w-3 h-3 rounded-full animate-pulse bg-green-400"></div>
                            <p className='ml-2 text-sm text-green-500'>{post?.state}</p>
                        </div>
                    }
                    {
                        post?.state === "Ongoing" && <div className='bg-trans text-white px-2 rounded flex items-center cursor-pointer'>
                            <div className="w-3 h-3 rounded-full animate-pulse bg-sky-400"></div>
                            <p className='ml-2 text-sm text-sky-500'>{post?.state}</p>
                        </div>
                    }
                    {
                        post?.state === "Finished" && <div className='bg-trans text-white px-2 rounded flex items-center cursor-pointer'>
                            <div className="w-3 h-3 rounded-full animate-pulse bg-gray-400"></div>
                            <p className='ml-2 text-sm text-gray-500'>{post?.state}</p>
                        </div>
                    }
                </div>
                <div className='flex items-center text-2xl font-bold mt-2'>
                    <BiCurrentLocation className='text-yellow-700' />
                    <p className="ml-2">{post?.place}, {post?.spot}</p>
                </div>
                <div className='flex items-center'>
                    <div className='flex items-center'>
                        <RiCalendarCheckLine className='text-yellow-700' />
                        <p className="text ml-2">{post?.date}</p>
                    </div>
                    <div className='flex items-center text-sm font-medium bg-pink-500 px-2 rounded text-white ml-4'>
                        <MdUpdate className='' />
                        <p className="ml-1">{formatTime(post?.time)}</p>
                    </div>
                </div>
                <div className='text-sm pt-4'>
                    <p><span className='font-bold text-yellow-600'>Description : </span>{post?.text}</p>
                </div>
                <div className='font-semibold pt-4'>
                    <p><span className='font-bold text-yellow-600'>Duration : </span>{post?.days} Days</p>
                </div>
                {
                    post?.guide !== "" &&
                    <div className='font-semibold pt-4'>
                        <p><span className='font-bold text-yellow-600'>Guide : </span><Link to={`/u/${post?.guideId}`} className='text-sm font-medium bg-violet-500 px-2 rounded text-white ml-4'>{post?.guide}</Link></p>
                    </div>
                }
                <div className='flex pt-4'>
                    <div className='flex items-center text-sm font-medium bg-lime-600 px-2 rounded text-white mr-8'>
                        <BsPeopleFill />
                        <p className="ml-1">{post?.member} Persons</p>
                    </div>
                    <div className='flex items-center text-sm font-medium bg-sky-500 px-2 rounded text-white'>
                        <GiMoneyStack />
                        <p className="ml-1">{post?.budget} BDT</p>
                    </div>
                </div>
                <div className='flex my-4'>
                    <div className='flex items-center text-sm font-medium bg-yellow-500 px-2 rounded text-white mr-8'>
                        <FaStar />
                        <p className="ml-1">Interested : {post?.interested?.length - 1}</p>
                    </div>
                </div>
                {
                    post?.guide === "" && inPersons?.length !== 0 && <div className='my-8 w-11/12 md:w-2/3 lg:w-1/2 shadow-custom-lg rounded-lg'>
                        <div className="overflow-x-auto p-3">
                            <h1 className='text-center my-4 text-xl font-medium'>List of Interested Travellers</h1>
                            <table className="table-auto w-full">
                                <thead className="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
                                    <tr>
                                        <th></th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Name</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="text-red-600 font-semibold text-center">Action</div>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody className="text-sm divide-y divide-gray-100">
                                    {
                                        inPersons?.map(p =>
                                            <tr key={p?.id}>
                                                <td className='p-2'></td>
                                                <td className="p-2">
                                                    <Link to={`/u/${p?.id}`} className="text-left">{p?.name}</Link>
                                                </td>
                                                <td className="p-2">
                                                    <div className="flex justify-center">
                                                        <button onClick={() => handleDelete(p?.id)}>
                                                            <svg className="w-8 h-8 hover:text-red-600 rounded-full hover:bg-gray-100 p-1"
                                                                fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                                                </path>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
                {
                    inGuides?.length !== 0 && <div className='my-8 w-11/12 md:w-2/3 lg:w-1/2 shadow-custom-lg rounded-lg'>
                        <div className="overflow-x-auto p-3">
                            <h1 className='text-center my-4 text-xl font-medium'>List of Interested Guides</h1>
                            <table className="table-auto w-full">
                                <thead className="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
                                    <tr>
                                        <th></th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Name</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="text-red-600 font-semibold text-center">Action</div>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody className="text-sm divide-y divide-gray-100">
                                    {
                                        inGuides?.map(p =>
                                            <tr key={p?.id}>
                                                <td className='p-2'></td>
                                                <td className="p-2">
                                                    <Link to={`/u/${p?.id}`} className="text-left">{p?.name}</Link>
                                                </td>
                                                <td className="p-2">
                                                    <div className="flex justify-center">
                                                        <button onClick={() => handleSelect(p)}>
                                                            <div className='flex items-center justify-center w-8 h-8 hover:text-green-600 rounded-full hover:bg-gray-100 p-1'>
                                                                <FaCheck className='text-lg' />
                                                            </div>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
                <div className='flex flex-wrap'>
                    {
                        post?.state === "Running" && userq?.email === user?.email && <div className='inline-flex'>
                            <div onClick={handleStart} className='mr-8 bg-trans text-white py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                                <p className='mr-2'>Start Tour</p>
                                <AiOutlineArrowRight className='text-lg' />
                            </div>
                        </div>
                    }
                    {
                        post?.state === "Running" && userq?.email === user?.email && <div className='inline-flex'>
                            <div onClick={handleCancel} className='mr-8 bg-trans text-white py-2 px-3 mt-2 rounded flex items-center cursor-pointer'>
                                <p className='mr-2'>Cancel Tour</p>
                                <AiOutlineArrowRight className='text-lg' />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default PostDeatils;